export const STRETCH_SESSION_TEMPLATE_TYPES = [
  'RECOVER_STRETCH_YOGA_FLOW',
  'RECOVER_STRETCH_WIND_DOWN',
  'RECOVER_STRETCH_FULL_BODY_FLOW',
  'RECOVER_STRETCH_REVIVE_RECOVER',
  'RECOVER_STRETCH_HIPS_LEGS',
  'RECOVER_STRETCH_ENERGY_BOOSTER',
  'RECOVER_STRETCH_BACK_CHEST_FOAM_ROLLER',
  'RECOVER_STRETCH_LOWER_BODY_FOAM_ROLLER',
  'DAILY_5_STRETCH',
  'DAILY_5_SEATED_STRETCH',
];

export const GUIDED_WORKOUT_TEMPLATE_TYPES = [
  'DYNAMIC_DUMBBELLS',
  'CHIPPER_WORKOUT',
  'LOW_IMPACT_LOWER_BODY',
  'CARRIES_CARDIO',
  'DUMBBELL_HIIT',
  'STRONG_AND_SCULPTED_ARMS',
  'EVES_GO_TO_WARMUP',
  'LEG_DAY_WITH_CARRIE_AND_EVE',
  'FIVE_X_FIVE_WORKOUT',
  'EVES_COOL_DOWN_SESSION',
  'EVES_MOBILITY_SESSION',
  'THE_FIT52_TEST',
  'INTRO_TO_FIT52',
  'LOWER_BODY_BURN',
  'UPPER_BODY_BLAST',
  'KETTLEBELLS_WITH_CARRIE',
  'CARRIES_HOT_HIIT',
];

export const YOGA_TEMPLATE_TYPES = [
  'YOGA_BASICS',
  'YOGA_FLOW_ESSENTIALS',
  'YOGA_CORE_STRENGTH',
  'YOGA_RESTORATIVE',
  'YOGA_POWER_FLOW',
  'YOGA_FOR_EVERYONE',
];
